module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Epigraph"
    }
  }, [_c('p', {
    staticClass: "fmh1",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Contents#repi"
    }
  }, [_vm._v("EPIGRAPH")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Bone of my bone thou art, and from thy state"), _c('br'), _vm._v("Mine never shall be parted, weal or woe.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—John Milton, "), _c('i', [_vm._v("Paradise Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "extractl"
  }, [_vm._v("Do what thy manhood bids thee do"), _c('br'), _vm._v("From none but self expect applause;"), _c('br'), _vm._v("He noblest lives and noblest dies"), _c('br'), _vm._v("Who makes and keeps his self-made laws.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—Sir Richard Francis Burton")]), _vm._v(" "), _c('p', {
    staticClass: "extractla"
  }, [_vm._v("Yes, I am proud; I must be proud to see"), _c('br'), _vm._v("Men not afraid of God, afraid of me.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—Alexander Pope, “Epistle to Dr. Arbuthnot”")]), _vm._v(" "), _c('p', {
    staticClass: "extracta"
  }, [_vm._v("Life is contemptuous of knowledge; it forces it to sit in the anterooms, to wait outside. Passion, energy, lies: these are what life admires.")]), _vm._v(" "), _c('p', {
    staticClass: "right10"
  }, [_vm._v("—James Salter, "), _c('i', [_vm._v("Light Years")])]), _vm._v(" "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea2e240c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780802156969_Front2.vue
// module id = 75
// module chunks = 0